"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryController = exports.ConfigurationTable = exports.SummaryTableRow = exports.SummaryTable = exports.LocationSummary = exports.MetricCategory = exports.Metric = exports.EffectType = exports.ChartValue = void 0;
const axios_1 = __importDefault(require("axios"));
const downloadFile_1 = __importDefault(require("@common/tsutils/downloadFile"));
const Summary_1 = __importDefault(require("@becrop/components/TrialsSummary/Abstract/models/Summary"));
const Configuration_1 = require("@becrop/components/Results/TrialsResults/Abstract/Models/Configuration");
const trans_1 = require("@common/tsutils/trans");
//import { toHandlers } from 'vue';
/* import { fakeSummary } from './fakeSummary'
import { fakeSummaryRenderer } from './fakeSummaryRenderer' */
const builtEndpoint = (projCode, studyId) => {
    let project = 'random';
    let study = 'random';
    if (projCode)
        project = projCode;
    if (project.length === 0)
        project = 'random';
    if (studyId)
        study = studyId;
    const baseURL = ` /results/api/project/${projCode}/summary/${studyId}`;
    // const baseURL = ` /results/api/project/434/summary/random`;
    return baseURL;
};
class ChartValue {
    constructor(obj) {
        this.name = obj.name || '#Product';
        this.value = obj.value || 0;
        this.score_change = obj.score_change;
        this.isRelevant = obj.isRelevant || false;
        this.is_significant = obj.is_significant || false;
        this.effectName = obj.effectName || '';
        this.claimType = obj.claimType || '-';
    }
}
exports.ChartValue = ChartValue;
class EffectType {
    constructor(obj) {
        this.name = obj.name || '#EffectType';
        this.productValues = obj.productValues || new Array();
    }
}
exports.EffectType = EffectType;
class Metric {
    constructor(obj) {
        this.name = obj.name || '#Metric';
        this.nature = obj.nature || false;
        this.effectType = obj.effectType || new Array();
    }
    parsePhchMetric(metricpPhch) {
        throw new Error('Method not implemented.');
    }
}
exports.Metric = Metric;
class MetricCategory {
    constructor(obj) {
        this.parentCategory = obj.parentCategory || '#Parent Category';
        this.name = obj.name || '#Category';
        this.metrics = obj.metrics || new Array();
    }
}
exports.MetricCategory = MetricCategory;
class LocationSummary {
    constructor(obj) {
        this.name = obj.name || '#Location';
        this.metricCategories = obj.metricCategories || new Array();
    }
}
exports.LocationSummary = LocationSummary;
class SummaryTable {
    constructor(obj) {
        this.configuration = obj.configuration || { locations: [] };
        this.reports = obj.reports || new Array();
        this.metadata = obj.metadata || { name: '#Name', description: '#Description', version: '', project_has_multiple_trial: false };
        this.thresholds = obj.thresholds || {
            effect: 0.05,
            majorChange: 0.2,
            trend: { min: 0.01, max: 0.3 },
        };
        this.products = obj.products || new Array();
        this.effectNames = obj.effectNames || new Array();
    }
}
exports.SummaryTable = SummaryTable;
class SummaryTableRow {
    constructor(obj) {
        this.location = obj.location || '#Location';
        this.parentCategory = obj.parentCategory || '#Parent Category';
        this.category = obj.category || '#Category';
        this.metric = obj.metric || '#Metric';
        this.effectType = obj.effectType || '#Effect Type';
        this.effectName = obj.effectName || '#Effect Name';
        this.transposedHelper = obj.location || '#TransposedHelper';
        this.chartValues = obj.productValues || new Array();
        this.frontierLocationCell = obj.frontierLocationCell || true;
        this.frontierCategoryCell = obj.frontierCategoryCell || true;
        this.frontierMetricCell = obj.frontierMetricCell || true;
        this.transposedFlag = obj.transposedFlag || false;
    }
}
exports.SummaryTableRow = SummaryTableRow;
class ConfigurationTable {
    constructor() {
        this.effectType = '';
        this.location = '';
        this.parentCategory = '';
        this.category = '';
        this.metric = '';
        this.claim = '';
        this.relevant = '';
        this.effectname = '';
    }
}
exports.ConfigurationTable = ConfigurationTable;
class SummaryController {
    constructor(obj) {
        this.summaryGlobalData = new Summary_1.default();
        this.defaultFilterValues = ['No Selected', 'No elegido', 'Non sélectionné', ''];
        this.tabs = [
            {
                key: 'global',
                name: (0, trans_1.trans)('becrop::summary.tab.global.name'),
                title: (0, trans_1.trans)('becrop::summary.tab.global.title'),
                active: true,
            },
            {
                key: 'table',
                name: (0, trans_1.trans)('becrop::summary.tab.table.name'),
                title: (0, trans_1.trans)('becrop::summary.tab.table.title'),
                active: false,
            },
        ];
        this.lastTrialsIDKey = 'lastTrialsID';
        this.lastTrialsNameKey = 'lastTrialsName';
        this.locationColKey = 'locations';
        this.treatmentColKey = 'treatments';
        this.timesColKey = 'times';
        this.productSorting = 'asc';
        this.summary = new SummaryTable(obj);
        this.customSummary = this.rowifyTable(this.summary);
        this.cleanTable = true;
        this.filterConfiguration = new ConfigurationTable();
        this.criteria = '';
        this.direction = 0;
        this.focusOn = 'Treatments';
        this.preferredValue = obj.preferredValue || '';
        this.omisibleColumns = [];
        this.type = obj.type || 'trials';
        this.isVS = obj.vs;
        this.configurationData = new Configuration_1.Configuration({});
        this.isComparisonAvailable = false;
        this.proposalID = obj.proposalID || -1;
    }
    async fetchSummaryTable(projectBagId, studyId) {
        try {
            const endpointURL = builtEndpoint(projectBagId, studyId);
            const res = await axios_1.default.get(endpointURL);
            const metadata = res.data.metadata;
            const thresholds = res.data.threshold;
            const products = res.data.products;
            const effectNames = res.data.effectNames;
            const locationsSummary = res.data.reports.map((loc) => {
                const name = loc.name;
                const metricCategories = loc.metricCategories.map((mc) => {
                    const mcName = mc.name;
                    const mcParentCategory = mc.parentCategory.toLowerCase().trim() ===
                        `${(0, trans_1.trans)('metrics.categories_in_table.Plant Growth Promoters')}`.toLowerCase().trim()
                        ? mc.name
                        : mc.parentCategory;
                    const mcMetrics = mc.metrics.map((me) => {
                        const meName = me.name;
                        const meNature = me.nature;
                        const meEffectType = me.effectType
                            .map((et) => {
                            const etName = et.name;
                            const etProdValues = et.productValues.map((pv) => {
                                var _a;
                                const pvName = pv.name;
                                const pvValue = pv.value;
                                const pvScoreChange = (_a = pv.score_change) !== null && _a !== void 0 ? _a : null;
                                const pvRelevant = pv.isRelevant;
                                const pvClaimType = pv.claimType;
                                const effectName = pv.effectName;
                                const is_significant = pv.is_significant;
                                return new ChartValue({
                                    name: pvName,
                                    value: pvValue,
                                    score_change: pvScoreChange,
                                    isRelevant: pvRelevant,
                                    effectName: effectName,
                                    claimType: pvClaimType,
                                    is_significant: is_significant,
                                });
                            });
                            return new EffectType({
                                name: etName,
                                productValues: etProdValues,
                            });
                        })
                            .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
                        return new Metric({
                            name: meName,
                            nature: meNature,
                            effectType: meEffectType,
                        });
                    });
                    return new MetricCategory({
                        parentCategory: mcParentCategory,
                        name: mcName,
                        metrics: mcMetrics,
                    });
                });
                return new LocationSummary({
                    name: name,
                    metricCategories: metricCategories,
                });
            });
            const summaryTableObj = {
                metadata: metadata,
                reports: locationsSummary,
                thresholds: thresholds,
                products: products,
                effectNames: effectNames,
            };
            const summaryTable = new SummaryTable(summaryTableObj);
            this.setSummaryTable(summaryTable);
            return summaryTable;
        }
        catch (e) {
            console.log(e);
        }
    }
    async fetchTrialsSummaryTable(projectBagId, gheomId) {
        try {
            const forbiddenSubstr = ['::', '#'];
            const endpointURL = `/results/api/project/${projectBagId}/summary/trials${!gheomId ? '' : '/' + gheomId}`;
            const res = await axios_1.default.get(endpointURL);
            const metadata = res.data.metadata;
            const configuration = res.data.configuration;
            const thresholds = res.data.threshold;
            const products = res.data.products;
            const effectNames = res.data.effectNames;
            const locationsSummary = res.data.reports.map((loc) => {
                const name = loc.name;
                const metricCategories = loc.metricCategories
                    .filter((fmc) => forbiddenSubstr.every((s) => !fmc.name.includes(s)))
                    .map((mc) => {
                    const mcName = mc.name;
                    const mcParentCategory = mc.parentCategory.toLowerCase().trim() ===
                        `${(0, trans_1.trans)('metrics.categories_in_table.Plant Growth Promoters')}`.toLowerCase().trim()
                        ? mc.name
                        : mc.parentCategory;
                    const mcMetrics = mc.metrics
                        .filter((fme) => forbiddenSubstr.every((s) => !fme.name.includes(s) && fme.name.length > 0))
                        .map((me) => {
                        const meName = me.name;
                        const meNature = me.nature;
                        const meEffectType = me.effectType.map((et) => {
                            const etName = et.name;
                            const etProdValues = et.productValues.map((pv) => {
                                var _a;
                                const pvName = pv.name;
                                const pvValue = pv.value;
                                const pvScoreChange = (_a = pv.score_change) !== null && _a !== void 0 ? _a : null;
                                const pvRelevant = pv.isRelevant;
                                const pvClaimType = pv.claimType;
                                const effectName = pv.effectName;
                                const is_significant = pv.is_significant;
                                return new ChartValue({
                                    name: pvName,
                                    value: pvValue,
                                    score_change: pvScoreChange,
                                    isRelevant: pvRelevant,
                                    effectName: effectName,
                                    claimType: pvClaimType,
                                    is_significant: is_significant,
                                });
                            });
                            return new EffectType({
                                name: etName,
                                productValues: etProdValues,
                            });
                        });
                        return new Metric({
                            name: meName,
                            nature: meNature,
                            effectType: meEffectType,
                        });
                    });
                    return new MetricCategory({
                        parentCategory: mcParentCategory,
                        name: mcName,
                        metrics: mcMetrics,
                    });
                });
                return new LocationSummary({
                    name: name,
                    metricCategories: metricCategories,
                });
            });
            const summaryTableObj = {
                configuration: configuration,
                metadata: metadata,
                reports: locationsSummary,
                thresholds: thresholds,
                products: products,
                effectNames: effectNames,
            };
            this.isComparisonAvailable = summaryTableObj.metadata.isComparisonAvailable;
            const summaryTable = new SummaryTable(summaryTableObj);
            let locations = [];
            configuration.locations.forEach((l) => {
                let myLocation = l;
                let treatments = [];
                l.treatments.forEach((treat) => {
                    let myTreatment = treat;
                    let times = [];
                    treat.times.forEach((t) => {
                        let myTime = t;
                        let samples = [];
                        t.samples.forEach((s) => {
                            let mySample = s;
                            samples.push(new Configuration_1.SampleConfiguration(mySample));
                        });
                        times.push(new Configuration_1.TimeConfiguration(Object.assign(Object.assign({}, myTime), { lineage: l.name + ' + ' + myTreatment.name + ' + ' + 'T' + myTime.time, samples: samples })));
                    });
                    treatments.push(new Configuration_1.TreatmentConfiguration(Object.assign(Object.assign({}, myTreatment), { lineage: l.name + ' + ' + myTreatment.name, times: times })));
                });
                locations.push(new Configuration_1.LocationConfiguration(Object.assign(Object.assign({}, myLocation), { treatments: treatments })));
            });
            this.configurationData = new Configuration_1.Configuration({
                locations: locations,
            });
            this.setSummaryTable(summaryTable);
            return summaryTable;
        }
        catch (e) {
            console.log(e);
        }
    }
    setSummaryGlobalData(summary) {
        this.summaryGlobalData = summary;
    }
    async fetchSummaryGlobalData(gheomId) {
        try {
            const response = (await axios_1.default.get(`/trials/summary/report/${gheomId}?renderer=puppeteer-payload`)).data;
            this.summaryGlobalData = new Summary_1.default(response);
        }
        catch (e) {
            this.summaryGlobalData = new Summary_1.default();
        }
    }
    get lastTrialsID() {
        return localStorage.getItem(this.lastTrialsIDKey);
    }
    get lastTrialsName() {
        return localStorage.getItem(this.lastTrialsNameKey);
    }
    setProposalID(id) {
        this.proposalID = id;
    }
    toggleComparison() {
        if (this.isVS) {
            let currentURL;
            if (this.lastTrialsID) {
                currentURL = `${window.location.href}/${this.lastTrialsID}`;
            }
            else {
                currentURL = `/results/projects?proposal=${this.proposalID}`;
            }
            localStorage.removeItem(this.lastTrialsIDKey);
            localStorage.removeItem(this.lastTrialsNameKey);
            window.location.href = currentURL;
        }
        else {
            const currentURL = window.location.href;
            const newURL = currentURL.substring(0, currentURL.lastIndexOf('/'));
            localStorage.setItem(this.lastTrialsIDKey, currentURL.substring(currentURL.lastIndexOf('/') + 1));
            localStorage.setItem(this.lastTrialsNameKey, this.summaryGlobalData.product.name);
            window.location.href = newURL;
        }
    }
    // TABLE SETUP
    setSummaryTable(sumTable) {
        this.summary = sumTable;
        this.customSummary = this.rowifyTable(this.summary);
    }
    resetTable() {
        if (this.focusOn === '')
            this.customSummary = this.rowifyTable(this.summary);
    }
    /*     resetTableWithConfiguration() {
        // Reset with actual config of filters/sorting/focus
        this.resetTable();
        this.refreshFilters();
    } */
    updateOmisibleColumns() {
        this.omisibleColumns = [];
        if (this.customSummary.length > 0) {
            if (this.customSummary.every((r) => r.location === this.customSummary[0].location)) {
                this.omisibleColumns.push(this.locationColKey);
            }
            if (this.customSummary.every((r) => r.category === this.customSummary[0].category)) {
                this.omisibleColumns.push('category');
            }
            if (this.customSummary.every((r) => r.parentCategory === this.customSummary[0].parentCategory)) {
                this.omisibleColumns.push('parentCategory');
            }
            if (this.customSummary.every((r) => r.effectType === this.customSummary[0].effectType)) {
                if (this.type === 'trials') {
                    this.omisibleColumns.push(this.timesColKey);
                }
            }
            if (this.currentFocus.toLowerCase() === this.timesColKey) {
                this.omisibleColumns.push('times');
            }
            if (this.currentFocus.toLowerCase() === this.locationColKey) {
                if (this.customSummary.every((r) => r.transposedHelper === this.customSummary[0].transposedHelper)) {
                    this.omisibleColumns.push('treatments');
                }
            }
            if (this.type === 'study') {
                if (this.customSummary.every((r) => r.effectType === this.customSummary[0].effectType)) {
                    this.omisibleColumns.push('effectname');
                }
            }
        }
    }
    get tableTitle() {
        let temp = `${(0, trans_1.trans)('trialsSummaryPublic.showing')} ${(0, trans_1.trans)('trialsSummaryPublic.values')} `;
        if (this.omisibleColumns.length === 0) {
            temp = `${(0, trans_1.trans)('trialsSummaryPublic.showing')}  ${(0, trans_1.trans)('trialsSummaryPublic.values')}`;
        }
        else {
            if (this.omisibleColumns.includes('metric')) {
                temp += `${(0, trans_1.trans)('trialsSummaryPublic.of')} <span>${this.customSummary[0].metric.name}</span> `;
                if (this.omisibleColumns.includes('category')) {
                    temp += `(<span>${this.customSummary[0].category}</span>) `;
                }
            }
            if (this.omisibleColumns.includes('parentCategory') && !this.omisibleColumns.includes('metric')) {
                temp += `${(0, trans_1.trans)('trialsSummaryPublic.of')} <span>${this.customSummary[0].parentCategory}</span> category `;
            }
            if (this.omisibleColumns.includes('category') && !this.omisibleColumns.includes('metric')) {
                temp += `${(0, trans_1.trans)('trialsSummaryPublic.of')} <span>${this.customSummary[0].category}</span> sub-category `;
            }
            if (this.type === 'trials') {
                if (this.omisibleColumns.includes(this.timesColKey) && this.focusOn.toLowerCase() !== 'times') {
                    temp += `${(0, trans_1.trans)('trialsSummaryPublic.during')} <span>${this.customSummary[0].effectType.substring(0, this.customSummary[0].effectType.indexOf('-'))}</span> `;
                }
            }
            else {
                if (this.omisibleColumns.includes('effectname')) {
                    temp += `(${this.customSummary[0].effectType}) `;
                }
            }
            if (this.omisibleColumns.includes(this.locationColKey) && this.focusOn.toLowerCase() !== 'locations') {
                temp += `${(0, trans_1.trans)('trialsSummaryPublic.in')} <span>${this.customSummary[0].location}</span> `;
            }
            if (this.omisibleColumns.includes(this.treatmentColKey)) {
                temp += `${(0, trans_1.trans)('trialsSummaryPublic.about')} <span>${this.customSummary[0].transposedHelper}</span> `;
            }
        }
        temp += ` (${this.customSummary.length})`;
        return temp;
    }
    // PRODUCT SORTING
    changeProductSortingDirection(newDir) {
        this.productSorting = newDir;
        this.updateWithProductSorting();
    }
    updateWithProductSorting() {
        this.updateProductSortInHead();
        this.updateProductSortInRows();
    }
    updateProductSortInHead() {
        this.summary.products = this.summary.products.sort((a, b) => {
            // Asc
            if (this.productSorting === 'asc') {
                if (a < b)
                    return -1;
                if (a > b)
                    return 1;
                return 0;
            }
            // Desc
            if (this.productSorting === 'desc') {
                if (a > b)
                    return -1;
                if (a < b)
                    return 1;
                return 0;
            }
            return 0;
        });
    }
    updateProductSortInRows() {
        this.customSummary.forEach((row) => {
            row.chartValues.sort((a, b) => {
                // Asc
                if (this.productSorting === 'asc') {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                }
                // Desc
                if (this.productSorting === 'desc') {
                    if (a.name > b.name)
                        return -1;
                    if (a.name < b.name)
                        return 1;
                    return 0;
                }
                return 0;
            });
        });
    }
    // FOCUS ON
    get currentFocus() {
        return this.focusOn;
    }
    get currentPreferredValue() {
        return this.preferredValue;
    }
    setFocus(f) {
        this.focusOn = f;
        this.updateWithFocusOn();
    }
    setPreferredValue(f) {
        this.preferredValue = f;
        this.updateWithFocusOn();
    }
    // FILTER INTERACTION
    refreshFilters() {
        this.updateWithFilters(false);
    }
    setFilter(filter, value) {
        if (filter === 'time') {
            this.filterConfiguration['effectType'] = value;
        }
        else {
            // @ts-ignore
            this.filterConfiguration['' + filter + ''] = value;
        }
        let requiresFullTable = true;
        this.updateWithFilters(requiresFullTable);
    }
    resetAllFilters() {
        for (const key in this.filterConfiguration) {
            // @ts-ignore
            this.filterConfiguration[key] = '';
        }
    }
    filterRow(row) {
        function filterEffectName(row, en) {
            if (row.chartValues.some((pv) => pv.effectName.toLowerCase() === en.toLowerCase())) {
                return true;
            }
            else {
                return false;
            }
        }
        function filterClaim(row, claim) {
            if (row.chartValues.some((pv) => !claim || pv.claimType === claim.toLowerCase())) {
                return true;
            }
            else {
                return false;
            }
        }
        function filterRelevant(row, relevant) {
            let relBoolean = false;
            if (relevant == 'true')
                relBoolean = true;
            if (relBoolean) {
                if (row.chartValues.some((pv) => Math.abs(pv.value) >= 1)) {
                    return true;
                }
                else {
                    return false;
                }
                /*                 if (this.type === 'trials') {
                
                                }
                                if (this.type === 'study') {
                                    if (row.chartValues.some((pv:ChartValue) => pv.isRelevant === true)) {
                                        return true;
                                    } else {
                                        return false;
                                    }
                                } */
            }
            else {
                return true;
            }
        }
        // @ts-ignore
        if (
        // @ts-ignore
        (this.defaultFilterValues.includes(this.filterConfiguration.location) || row.location === this.filterConfiguration.location) &&
            // @ts-ignore
            (this.defaultFilterValues.includes(this.filterConfiguration.category) || row.category === this.filterConfiguration.category) &&
            // @ts-ignore
            (this.defaultFilterValues.includes(this.filterConfiguration.parentCategory) ||
                row.parentCategory === this.filterConfiguration.parentCategory) &&
            // @ts-ignore
            (this.defaultFilterValues.includes(this.filterConfiguration.metric) || row.metric.name === this.filterConfiguration.metric) &&
            // @ts-ignore
            (this.defaultFilterValues.includes(this.filterConfiguration.claim) || filterClaim(row, this.filterConfiguration.claim)) &&
            // @ts-ignore
            (this.defaultFilterValues.includes(this.filterConfiguration.relevant) || filterRelevant(row, this.filterConfiguration.relevant)) &&
            // @ts-ignore
            (this.defaultFilterValues.includes(this.filterConfiguration.effectname) || filterEffectName(row, this.filterConfiguration.effectname)) &&
            // @ts-ignore
            (this.defaultFilterValues.includes(this.filterConfiguration.effectType) || row.effectType.includes(this.filterConfiguration.effectType))) {
            return true;
        }
        return false;
    }
    updateWithFilters(requiresFullTable) {
        //this.customSummary = this.rowifyTable(this.summary);
        if (requiresFullTable) {
            this.buildCustomSummary();
        }
        const tempCustomSummary = this.customSummary
            .filter((row) => {
            if (this.filterRow(row)) {
                return true;
            }
            else {
                return false;
            }
        })
            .map((r) => r);
        this.customSummary = this.polishRows(tempCustomSummary);
        /*         if (filter.length > 0 && value.length > 0 && filter === 'time') {
            this.customSummary = this.customSummary.filter((item) => {
                return item.effectType.includes(value);
            });
        } */
        this.updateProductSortInRows();
        this.updateOmisibleColumns();
    }
    hasFilterOfType(type) {
        let hasFilter = true;
        // @ts-ignore
        if (this.defaultFilterValues.includes(this.filterConfiguration[type])) {
            hasFilter = false;
        }
        return hasFilter;
    }
    get isShowingOnlyRelevant() {
        if (this.filterConfiguration.relevant == 'true')
            return true;
        return false;
    }
    get hasAFilterActive() {
        return Object.values(this.filterConfiguration).some((v) => !this.defaultFilterValues.includes(v));
    }
    // SORTING INTERACTION
    resetDirection() {
        this.direction = 0;
    }
    moveDirection() {
        const directionsLibrary = [-1, 0, 1];
        const currDirectionIx = directionsLibrary.findIndex((d) => d === this.direction);
        let nextDirectionIx = currDirectionIx + 1;
        if (currDirectionIx === directionsLibrary.length - 1)
            nextDirectionIx = 0;
        this.setDirection(directionsLibrary[nextDirectionIx]);
    }
    setDirection(d) {
        this.direction = d;
    }
    setCriteria(c) {
        this.criteria = c;
    }
    chooseCriteria(criteria) {
        if (this.criteria === criteria) {
            this.moveDirection();
        }
        else {
            this.setCriteria(criteria);
            this.resetDirection();
            this.moveDirection();
        }
        this.updateWithSorting();
    }
    updateWithSorting() {
        const standardSortings = ['location', 'category', 'parentCategory', 'effectType'];
        const keyToSort = this.criteria;
        // @ts-nocheck
        this.customSummary = this.customSummary.sort((a, b) => {
            if (standardSortings.includes(keyToSort)) {
                if (this.direction === -1) {
                    // @ts-ignore
                    return a[keyToSort] > b[keyToSort] ? -1 : 1;
                }
                else if (this.direction === 1) {
                    // @ts-ignore
                    return a[keyToSort] < b[keyToSort] ? -1 : 1;
                }
            }
            if (keyToSort === 'metric') {
                if (this.direction === -1) {
                    return a.metric.name > b.metric.name ? -1 : 1;
                }
                else if (this.direction === 1) {
                    return a.metric.name < b.metric.name ? -1 : 1;
                }
            }
            if (keyToSort === 'treatment') {
                if (this.direction === -1) {
                    return a.transposedHelper > b.transposedHelper ? -1 : 1;
                }
                else if (this.direction === 1) {
                    return a.transposedHelper < b.transposedHelper ? -1 : 1;
                }
            }
            if (keyToSort !== 'metric' && keyToSort !== 'treatment' && !standardSortings.includes(keyToSort)) {
                if (this.currentPreferredValue === 'score_change') {
                    if (this.direction === -1) {
                        if (!!a.chartValues[parseInt(keyToSort)].score_change && !!b.chartValues[parseInt(keyToSort)].score_change) {
                            // @ts-ignore
                            return a.chartValues[parseInt(keyToSort)].score_change > b.chartValues[parseInt(keyToSort)].score_change ? -1 : 1;
                        }
                        // if some value is undefined
                        return !!a.chartValues[parseInt(keyToSort)].score_change ? -1 : 1;
                    }
                    else if (this.direction === 1) {
                        if (!!a.chartValues[parseInt(keyToSort)].score_change && !!b.chartValues[parseInt(keyToSort)].score_change) {
                            // @ts-ignore
                            return a.chartValues[parseInt(keyToSort)].score_change < b.chartValues[parseInt(keyToSort)].score_change ? -1 : 1;
                        }
                        return !!a.chartValues[parseInt(keyToSort)].score_change ? 1 : -1;
                    }
                }
                if (this.direction === -1) {
                    return a.chartValues[parseInt(keyToSort)].value > b.chartValues[parseInt(keyToSort)].value ? -1 : 1;
                }
                else if (this.direction === 1) {
                    return a.chartValues[parseInt(keyToSort)].value < b.chartValues[parseInt(keyToSort)].value ? -1 : 1;
                }
            }
            return 0;
        });
        this.customSummary = this.polishRows(this.customSummary);
    }
    // SELECTORS
    get getAllEffectNames() {
        return this.summary.effectNames;
    }
    get hasLocations() {
        let hasLocations = false;
        if (this.summary.reports.length > 0)
            hasLocations = true;
        return hasLocations;
    }
    get getAllProducts() {
        return this.summary.products;
    }
    get getAllLocations() {
        if (this.hasLocations) {
            return this.summary.reports.map((l) => l);
        }
        else {
            return [];
        }
    }
    get allTimes() {
        const dataArray = new Configuration_1.Configuration(this.summary.configuration);
        const uniqueTimesObject = [];
        dataArray.locations.forEach((item) => {
            if (item.treatments && Array.isArray(item.treatments)) {
                item.treatments.forEach((treatment) => {
                    if (treatment.times && Array.isArray(treatment.times)) {
                        treatment.times
                            .filter((time) => time.time !== 0)
                            .forEach((time) => {
                            const myTime = time.time;
                            if (uniqueTimesObject.findIndex((t) => t.time === time.time) === -1) {
                                uniqueTimesObject.push(time);
                            }
                        });
                    }
                });
            }
        });
        //const uniqueTimesArray = Object.values(uniqueTimesObject);
        return uniqueTimesObject;
    }
    get getAllParentCategories() {
        const allCategories = [];
        if (this.hasLocations) {
            this.summary.reports.forEach((l) => {
                l.metricCategories.forEach((mc) => {
                    if (!allCategories.find((parentCategory) => parentCategory === mc.parentCategory)) {
                        allCategories.push(mc.parentCategory);
                    }
                });
            });
        }
        return allCategories;
    }
    get getAllCategories() {
        const allCategories = [];
        if (this.hasLocations) {
            this.summary.reports.forEach((l) => {
                l.metricCategories.forEach((mc) => {
                    if (!allCategories.find((ac) => ac.name === mc.name)) {
                        allCategories.push(mc);
                    }
                });
            });
        }
        return allCategories;
    }
    get getAllMetrics() {
        const allMetrics = [];
        if (this.hasLocations) {
            this.summary.reports.forEach((l) => {
                l.metricCategories.forEach((mc) => {
                    mc.metrics.forEach((me) => {
                        if (!allMetrics.find((am) => am.name === me.name)) {
                            allMetrics.push(me);
                        }
                    });
                });
            });
        }
        return allMetrics;
    }
    get currentCategory() {
        if (this.hasLocations) {
            let currentCategory = null;
            const allCategories = this.getAllCategories;
            if (!this.defaultFilterValues.includes(this.filterConfiguration.category)) {
                currentCategory = allCategories.find((c) => c.name === this.filterConfiguration.category);
            }
            return currentCategory;
        }
    }
    get currentParentCategory() {
        if (this.hasLocations) {
            let currentParentCategory = null;
            const allParentCategories = this.getAllParentCategories;
            if (!this.defaultFilterValues.includes(this.filterConfiguration.parentCategory)) {
                currentParentCategory = allParentCategories.find((c) => c === this.filterConfiguration.parentCategory);
            }
            return currentParentCategory;
        }
    }
    get getCurrentCategories() {
        let categories = [];
        if (this.hasLocations) {
            const currentParentCategory = this.currentParentCategory;
            if (currentParentCategory) {
                this.summary.reports.forEach((l) => {
                    l.metricCategories.forEach((c) => {
                        if (c.parentCategory === currentParentCategory) {
                            if (!categories.some((cat) => cat.name === c.name)) {
                                categories.push(c);
                            }
                        }
                    });
                });
            }
            else {
                categories = this.getAllCategories;
            }
        }
        return categories;
    }
    get getCurrentMetrics() {
        let metrics = [];
        if (this.hasLocations) {
            const currentCategory = this.currentCategory;
            const currentParentCategory = this.currentParentCategory;
            if (currentParentCategory) {
                this.summary.reports.forEach((l) => {
                    l.metricCategories.forEach((c) => {
                        if (c.parentCategory === currentParentCategory) {
                            c.metrics.forEach((m) => {
                                if (!metrics.find((me) => me.name === m.name)) {
                                    metrics.push(m);
                                }
                            });
                        }
                    });
                });
            }
            if (currentCategory) {
                metrics = [];
                this.summary.reports.forEach((l) => {
                    l.metricCategories.forEach((c) => {
                        if (c.name === currentCategory.name) {
                            c.metrics.forEach((m) => {
                                if (!metrics.find((me) => me.name === m.name)) {
                                    metrics.push(m);
                                }
                            });
                        }
                    });
                });
            }
            if (!currentParentCategory && !currentCategory) {
                metrics = this.getAllMetrics;
            }
        }
        return metrics;
    }
    get chartCols() {
        if (this.focusOn.toLowerCase() === this.locationColKey)
            return this.getAllLocations
                .filter((loc) => loc.name.toLowerCase() !== 'all')
                .map((l) => l.name)
                .sort();
        if (this.focusOn.toLowerCase() === this.treatmentColKey)
            return this.getAllProducts;
        if (this.focusOn.toLowerCase() === this.timesColKey)
            return this.allTimes.map((t) => 'T' + t.time);
    }
    get dynamicCols() {
        if (this.focusOn.toLowerCase() === this.locationColKey)
            return [this.treatmentColKey, this.timesColKey];
        if (this.focusOn.toLowerCase() === this.treatmentColKey)
            return [this.locationColKey, this.timesColKey];
        if (this.focusOn.toLowerCase() === this.timesColKey)
            return [this.locationColKey, this.treatmentColKey];
    }
    buildCustomSummary() {
        if (this.focusOn.toLowerCase() === this.locationColKey) {
            this.filterConfiguration.location = '';
            //if(this.type === 'study') filterConfiguration ''
            let initialTable = this.rowifyTable(this.summary);
            let tempTable = [];
            let tempRows = [];
            initialTable.forEach((row) => {
                //console.log(row.chartValues);
                row.chartValues.forEach((cv) => {
                    let newRow = Object.assign(Object.assign({}, row), { transposedHelper: cv.name });
                    tempRows.push(newRow);
                });
            });
            tempTable = tempRows;
            if (this.type === 'study') {
                tempTable = tempTable.filter((r) => r.location.toLowerCase() !== 'all');
            }
            let transposedTable = [];
            const chartCols = this.chartCols;
            tempTable.forEach((row) => {
                let newChartValues = [];
                if (this.getAllLocations.length === 1) {
                    newChartValues = row.chartValues
                        .filter((cv) => row.transposedHelper === cv.name)
                        .map((v) => {
                        return new ChartValue(Object.assign(Object.assign({}, v), { name: row.location }));
                    });
                }
                else {
                    if (!row.transposedFlag) {
                        let siblingRows = new Array();
                        if (this.type === 'trials') {
                            siblingRows = tempTable.filter((sRow) => sRow.metric.name === row.metric.name && sRow.effectType === row.effectType && sRow.location !== row.location);
                        }
                        else {
                            siblingRows = tempTable.filter((sRow) => sRow.metric.name === row.metric.name && sRow.location !== row.location);
                            siblingRows = siblingRows.filter((sRow) => sRow.location.toLowerCase() !== 'all');
                        }
                        newChartValues = row.chartValues
                            .filter((cv) => row.transposedHelper === cv.name)
                            .map((v) => {
                            return new ChartValue(Object.assign(Object.assign({}, v), { name: row.location }));
                        });
                        let restChartValues = [];
                        if (siblingRows.length > 0) {
                            siblingRows.forEach((r) => {
                                let siblingsChartValues = r.chartValues.map((c) => {
                                    return new ChartValue(Object.assign(Object.assign({}, c), { name: r.location }));
                                });
                                restChartValues = [...restChartValues, ...siblingsChartValues];
                                const trIndex = tempTable.findIndex((tr) => tr.metric === r.metric && tr.effectType === r.effectType);
                                tempTable[trIndex].transposedFlag = true;
                            });
                        }
                        if (newChartValues.length + restChartValues.length !== this.getAllLocations.length) {
                            let locations = this.getAllLocations;
                            if (this.type === 'study') {
                                locations = locations.filter((l) => l.name.toLowerCase() !== 'all');
                            }
                            newChartValues = locations.map((myLoc) => {
                                let storedIx = newChartValues.findIndex((nv) => nv.name === myLoc.name);
                                if (storedIx !== -1) {
                                    return newChartValues[storedIx];
                                }
                                else {
                                    storedIx = restChartValues.findIndex((rv) => rv.name === myLoc.name);
                                    if (storedIx !== -1) {
                                        return restChartValues[storedIx];
                                    }
                                    else {
                                        return new ChartValue({ name: myLoc.name });
                                    }
                                }
                            });
                        }
                        else {
                            newChartValues = [...newChartValues, ...restChartValues];
                        }
                        newChartValues.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
                    }
                }
                let transposedRow = Object.assign(Object.assign({}, row), { chartValues: newChartValues });
                if (transposedRow.chartValues.length > 0) {
                    transposedTable.push(transposedRow);
                }
            });
            /* console.log(transposedTable); */
            this.customSummary = [...transposedTable];
        }
        if (this.focusOn.toLowerCase() === this.treatmentColKey) {
            this.customSummary = this.rowifyTable(this.summary);
        }
        if (this.focusOn.toLowerCase() === this.timesColKey) {
            this.filterConfiguration.effectType = '';
            this.customSummary = this.rowifyTable(this.summary);
            let initialTable = this.rowifyTable(this.summary);
            let tempTable = [];
            let tempRows = [];
            initialTable.forEach((row) => {
                //console.log(row.chartValues);
                row.chartValues.forEach((cv) => {
                    let newRow = Object.assign(Object.assign({}, row), { transposedHelper: cv.name });
                    tempRows.push(newRow);
                });
            });
            tempTable = tempRows;
            let transposedTable = [];
            tempTable.forEach((row) => {
                let newChartValues = [];
                if (this.allTimes.length === 1) {
                    newChartValues = row.chartValues
                        .filter((cv) => row.transposedHelper === cv.name)
                        .map((v) => {
                        return Object.assign(Object.assign({}, v), { name: row.effectType.substring(0, row.effectType.indexOf('-')) });
                    });
                }
                else {
                    if (!row.transposedFlag) {
                        const siblingRows = tempTable.filter((sRow) => sRow.metric.name === row.metric.name && sRow.effectType !== row.effectType && sRow.location === row.location);
                        newChartValues = row.chartValues
                            .filter((cv) => row.transposedHelper === cv.name)
                            .map((v) => {
                            return Object.assign(Object.assign({}, v), { name: row.effectType.substring(0, row.effectType.indexOf('-')) });
                        });
                        let restChartValues = [];
                        if (siblingRows.length > 0) {
                            siblingRows.forEach((r) => {
                                const sibRestChartValues = r.chartValues.map((c) => {
                                    return Object.assign(Object.assign({}, c), { name: r.effectType.substring(0, r.effectType.indexOf('-')) });
                                });
                                const trIndex = tempTable.findIndex((tr) => tr.metric.name === r.metric.name && tr.effectType === r.effectType);
                                restChartValues = [...restChartValues, ...sibRestChartValues];
                                tempTable[trIndex].transposedFlag = true;
                            });
                        }
                        else {
                            const times = this.allTimes;
                            times.forEach((myTime) => {
                                if (!row.effectType.includes(`T${myTime.time}`)) {
                                    restChartValues.push(new ChartValue({ name: `T${myTime.time}` }));
                                }
                            });
                        }
                        newChartValues = [...newChartValues, ...restChartValues];
                    }
                }
                const times = this.allTimes;
                let filledChartValues = [];
                times.forEach((t) => {
                    const key = `T${t.time}`;
                    const currChartValue = newChartValues.find((v) => v.name === key);
                    if (currChartValue) {
                        filledChartValues.push(new ChartValue(currChartValue));
                    }
                    else {
                        filledChartValues.push(new ChartValue({ name: key }));
                    }
                });
                filledChartValues = filledChartValues.sort((a, b) => parseInt(b.name.slice(1), 10) - parseInt(a.name.slice(1), 10));
                let transposedRow = Object.assign(Object.assign({}, row), { chartValues: filledChartValues });
                if (!transposedRow.transposedFlag && transposedRow.chartValues.length > 0) {
                    transposedTable.push(transposedRow);
                }
            });
            this.customSummary = [...transposedTable];
            let removeDuplicates = (arr) => {
                const seen = new Set();
                return arr.filter((obj) => {
                    const key = `${obj.location}-${obj.metric.name}-${obj.transposedHelper}`;
                    if (seen.has(key))
                        return false;
                    seen.add(key);
                    return true;
                });
            };
            this.customSummary = removeDuplicates(this.customSummary);
        }
    }
    // BEAUTIFY TABLE
    updateWithFocusOn() {
        this.buildCustomSummary();
        this.refreshFilters();
        this.updateWithSorting();
    }
    polishRows(rows) {
        rows.forEach((row, i) => {
            if (i === 0) {
                row.frontierLocationCell = true;
                row.frontierCategoryCell = true;
                row.frontierMetricCell = true;
            }
            else {
                if (row.location !== rows[i - 1].location) {
                    row.frontierLocationCell = true;
                    row.frontierCategoryCell = true;
                    row.frontierMetricCell = true;
                }
                else {
                    row.frontierLocationCell = false;
                    row.frontierCategoryCell = false;
                    if (row.category !== rows[i - 1].category) {
                        row.frontierCategoryCell = true;
                        row.frontierMetricCell = true;
                    }
                    else {
                        if (row.metric.name !== rows[i - 1].metric.name) {
                            row.frontierMetricCell = true;
                        }
                        else {
                            row.frontierMetricCell = false;
                        }
                    }
                }
            }
        });
        return rows;
    }
    rowifyTable(sumTable) {
        let rows = [];
        if (sumTable.reports.length) {
            sumTable.reports.forEach((location) => {
                location.metricCategories.forEach((mc) => {
                    mc.metrics.forEach((me) => {
                        me.effectType.forEach((et) => {
                            const frontierLocationCell = false;
                            const frontierCategoryCell = false;
                            const frontierMetricCell = false;
                            const productValuesFixed = this.getAllProducts.map((p) => {
                                let productAnalyzed = et.productValues.find((pv) => {
                                    if (this.filterConfiguration.effectname.length > 0) {
                                        return pv.name === p && pv.effectName === this.filterConfiguration.effectname;
                                    }
                                    else {
                                        return pv.name === p;
                                    }
                                });
                                if (!productAnalyzed) {
                                    productAnalyzed = new ChartValue({
                                        name: p,
                                        value: 0,
                                        isRelevant: false,
                                        effectName: '',
                                    });
                                }
                                return productAnalyzed;
                            });
                            rows.push(new SummaryTableRow({
                                location: location.name,
                                parentCategory: mc.parentCategory,
                                category: mc.name,
                                metric: {
                                    name: me.name,
                                    nature: me.nature,
                                },
                                effectType: et.name,
                                transposedHelper: location.name,
                                productValues: productValuesFixed,
                                frontierLocationCell: frontierLocationCell,
                                frontierCategoryCell: frontierCategoryCell,
                                frontierMetricCell: frontierMetricCell,
                            }));
                        });
                    });
                });
            });
        }
        if (this.cleanTable) {
            rows = this.polishRows(rows);
        }
        return rows;
    }
    async downloadCSVConfig(raw_gheom, onlyConfig) {
        const url = '/results/api/trials/results-configuration/download/excel';
        let currentFilters = Object.assign({}, this.filterConfiguration);
        let filtersActive = this.parseFilterConfigurationToMultipleConfiguration(currentFilters);
        try {
            const data = {
                project_id: raw_gheom.project_id,
                gheom_id: raw_gheom.id,
                all: onlyConfig ? 0 : 1,
                filters: filtersActive,
                preferred_value: this.currentPreferredValue
            };
            const specialCharactersRegex = /[\/.%;!?¿$¡-]/g;
            let name = raw_gheom.name;
            const curatedName = name.replace(specialCharactersRegex, '');
            const fileName = onlyConfig ? `${curatedName} - Configuration` : `${curatedName} - Full`;
            const response = await axios_1.default.post(url, data, { responseType: 'blob' });
            (0, downloadFile_1.default)(response.data, fileName + ' - ' + this.currentPreferredValue, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        }
        catch (e) {
            console.log(e);
        }
    }
    parseFilterConfigurationToMultipleConfiguration(f) {
        let parsered = f;
        Object.keys(parsered).forEach(key => {
            if (typeof parsered[key] === 'string') {
                parsered[key] = [parsered[key]];
                if (parsered[key][0].length == 0)
                    parsered[key] = [];
            }
        });
        return parsered;
    }
}
exports.SummaryController = SummaryController;
